import { __assign } from "tslib";
import { useMemo } from 'react';
export function getDebugPerformance(debugLoggingEnabled) {
    if (debugLoggingEnabled) {
        return {
            start: function (params) {
                try {
                    var startTime_1 = performance.now();
                    return function (endParams) {
                        if (endParams === void 0) { endParams = {}; }
                        try {
                            var endTime = performance.now();
                            console.debug(__assign(__assign(__assign({}, params), endParams), { action: "Performance: ".concat(params.action), duration: endTime - startTime_1 }));
                        }
                        catch (_a) {
                            // ignore
                        }
                    };
                }
                catch (_a) {
                    // ignore
                }
                return function () { return undefined; };
            },
        };
    }
    return {
        start: function () { return function () { return undefined; }; },
    };
}
export var useDebugPerformanceLogger = function () {
    return useMemo(function () {
        return getDebugPerformance(false);
    }, []);
};
//# sourceMappingURL=useDebugPerformanceLogger.js.map